<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.processingTime.processingTimes') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('settings.backToSettings') }}
        </d-button>
        <d-button theme="success" @click.prevent="$router.push('/ustawienia/czas-realizacji/nowy')">
          <i class="material-icons">add</i>
          {{ $t('settings.processingTime.addNewProcessingTime') }}
        </d-button>
      </d-col>
    </d-row>

    <d-card style="width: 100%;">
      <table
        :class="{
          'table mt-0 mb-0 full-width': true,
          'is-loading': timesOrderSaveInProgress
        }">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">{{ $t('settings.processingTime.processingTimeName') }}</th>
            <th scope="col" class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <draggable
          v-if="loaded"
          v-model="times"
          tag="tbody">
          <tr
            v-for="(time, index) of times"
            :key="'time-' + index">
            <td class="align-middle">
              {{ time.name }}
            </td>
            <td
              class="align-middle"
              style="width: 200px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/ustawienia/czas-realizacji/edycja/' + time.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.native="removeTime(time.id)"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
        </draggable>
        <tbody v-if="times.length === 0">
          <tr>
            <td
              colspan="3"
              class="text-center">
              {{ $t('settings.processingTime.noProcessingTimesToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../utils/FormUtils.js';
import ListUtils from './../utils/ListUtils.js';
import vueDraggable from 'vuedraggable';

export default {
  name: 'times',
  components: {
    'draggable': vueDraggable,
  },
  data() {
    return {
      times: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      timesOrderSaveInProgress: false
    };
  },
  watch: {
    times (newValue, previousValue) {
      if (this.loaded && previousValue.length) {
        this.debouncedTimesOrdering();
      }
    }
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      ListUtils.loadItemsData(this, '/processing-time/items', 'times');
    },
    removeTime (timeID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/processing-time/delete/',
        id: timeID,
        successTitle: this.$t('settings.processingTime.removeProcessingTimeSuccessTitle'),
        successText: this.$t('settings.processingTime.removeProcessingTimeSuccessText'),
        confirmTitle: this.$t('settings.processingTime.removeProcessingTimeConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.processingTime.removeProcessingTimeErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    // eslint-disable-next-line
    debouncedTimesOrdering: debounce(function () {
      this.saveTimesOrder();
    }, 1000),
    saveTimesOrder () {
      this.timesOrderSaveInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/processing-time/ordering',
        formData: {
          items: this.times.map(time => time.id)
        },
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('ui.errorOccured'),
        successAction: () => {
          this.timesOrderSaveInProgress = false;
        },
        failAction: () => {
          this.timesOrderSaveInProgress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
table.is-loading {
  opacity: .25;
  pointer-events: none;
}
</style>
